// extracted by mini-css-extract-plugin
export default {"box":"RuleColumnsTable_box__4yXXj","tableScroll":"RuleColumnsTable_tableScroll__GS41w","table":"RuleColumnsTable_table__wdl9P"};